import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

export const initialPaymentAPI = async data => {
  try {
    const data = {
      amount: "2000",
      plan_details: "Plan details gold etc",
    }
    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }
    const response = await axios.post(
      `${apiBaseUrl}/initial-transaction`,
      data,
      { headers }
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

export const getCouponAPI = async payload => {
  try {
    const data = { coupon_code: payload }

    const response = await axios.post(
      `${apiBaseUrl}/check-coupon`,
      data
    )
    return response
  } catch (error) {
    console.log(error)
  }
}
